import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import React, {useEffect, useState} from "react";
import {chartColors} from "../../../component/charts/utils/ChartColors";
import {HabitationMonitoringService} from "../../../serverService/habitationMonitoring/HabitationMonitoringService";
import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoGridOneColumn, RaikoLabel,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import PieChartLineInfo from "../../../component/charts/pieChartWithPaddingAngle/pieChartLineInfo/PieChartLineInfo";


export default function HabitationMonitoringBarChartProvincePopulation({periodId, refreshFlag = false}) {

    const service = new HabitationMonitoringService()

    const [provincePopulationData, setProvincePopulationData] = useState([])

    function getDataFromServer() {
        service.getProvincesPopulation(periodId)
            .then(response => {
                setProvincePopulationData([])
                response.map((item, index) => {
                    setProvincePopulationData(prev => [
                        ...prev,
                        {
                            name: item.province,
                            men: item.numberOfMen,
                            women: item.numberOfWomen,
                            total: item.totalPeople,
                        },
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })
    }

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId >= 0) {
            getDataFromServer()
        }
    }, [periodId]);

    useEffect(() => {
        if (typeof refreshFlag !== "undefined" && refreshFlag) {
            getDataFromServer()
        }
    }, [refreshFlag]);


    return (
        <RaikoBaseCardContainer className={css`width: 100%;
            height: 450px `}>
            <RaikoGridOneColumn className={css`height: 100%;
                grid-auto-rows: auto 1fr;`}>
                <RaikoLabel text={"تراکم درخواست استان ها"} className={css`height: fit-content;`}/>
                <ResponsiveContainer className={css`direction: ltr;`}>
                    <BarChart
                        data={provincePopulationData}
                        margin={{top: 0, right: 0, left: 0, bottom: 0}}
                    >
                        {/* خطوط شبکه */}
                        <CartesianGrid strokeDasharray="1 2" stroke="#cccccc"/>

                        {/* محور X و Y */}
                        <XAxis
                            dataKey="name"
                            stroke="#aaa"
                            tick={{fontSize: 8, fill: "#1e1e1e"}}
                        />

                        {/* محور عمودی */}
                        <YAxis
                            dataKey="total"
                            stroke="#aaa"
                            tick={{fontSize: 12, fill: "#1e1e1e"}}
                            domain={[0, 10]}
                        />

                        {/* Tooltip با استایل دلخواه */}
                        <Tooltip
                            contentStyle={{
                                backgroundColor: "#1e1e2f",
                                border: `1px solid ${chartColors.green}`,
                                borderRadius: "5px",
                                direction: "rtl",
                            }}
                            labelStyle={{color: chartColors.green, textAlign: "right"}}
                            itemStyle={{color: "#fff", textAlign: "right"}}
                            formatter={(value, name) =>
                                [`${value}`, name === "men" ? "آقا" :
                                    name === "women" ? "خانم" :
                                        "مجموع"]}
                        />

                        {/* میله‌ها */}
                        <Bar
                            dataKey="total"
                            stackId="t"
                            fill={chartColors.cyan}
                            radius={[5, 5, 0, 0]}
                            barSize={10}
                        />
                        <Bar
                            dataKey="men"
                            stackId="m"
                            fill={chartColors.blue}
                            radius={[5, 5, 0, 0]}
                            barSize={10}
                        />
                        <Bar
                            dataKey="women"
                            stackId="w"
                            fill={chartColors.red}
                            radius={[5, 5, 0, 0]}
                            barSize={10}
                        />

                    </BarChart>
                </ResponsiveContainer>

                <div className={css`display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 1rem`}>
                    <PieChartLineInfo
                        color={chartColors.green}
                        value={""}
                        title={"مجموع"}
                    />
                    <PieChartLineInfo
                        color={chartColors.blue}
                        value={""}
                        title={"آقا"}
                    />
                    <PieChartLineInfo
                        color={chartColors.red}
                        value={""}
                        title={"خانم"}
                    />
                </div>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    );
}
